import AppointmentSearchAutocompleteContent from 'src/pages/MUIBased/ComponentLibrary/catalog/AppointmentSearchAutocompleteContent'
import ButtonContent from 'src/pages/MUIBased/ComponentLibrary/catalog/ButtonContent'
import TextFieldContent from 'src/pages/MUIBased/ComponentLibrary/catalog/TextFieldContent'
import TypographyContent from 'src/pages/MUIBased/ComponentLibrary/catalog/TypographyContent'

export default [
    AppointmentSearchAutocompleteContent,
    ButtonContent,
    TextFieldContent,
    TypographyContent
]
